import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';

import { salesforceUtils } from 'shared/utils';
import { createStylesHook } from 'shared/hooks';
import i18next from 'core/i18n';

const useStyles = createStylesHook(() => ({
  content: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 30
  }
}));

interface SalesforceLinkProps {
  id: string;
  isAccount?: boolean;
}

export const SalesforceLink: React.FunctionComponent<SalesforceLinkProps> = ({
  id,
  isAccount = false
}: SalesforceLinkProps): JSX.Element => {
  const link = salesforceUtils.getDetailURL(id, isAccount);

  const classes = useStyles();

  return (
    <div className={classes.content}>
      <a data-test="see-opp-on-SFDC" target="_blank" href={link} rel="noopener noreferrer">
        {isAccount ? i18next.t('seeAccountInfoOnSalesforce') : i18next.t('seeOpportunityOnSalesforce')}{' '}
        <FontAwesomeIcon icon={faChevronRight} />
      </a>
    </div>
  );
};
